import DeadBranchImage from "../../images/tasks/dead-branch.jpg";
import PitchforkSoilManImage from "../../images/tasks/pitchfork-soil-man.jpeg";
import ManLayingBrickPathImage from "../../images/tasks/man-laying-brick-path.jpeg";
import GardenFurnitureInSun from "../../images/tasks/garden-furniture-in-sun.jpeg";
import GardenTools from "../../images/tasks/garden-tools.jpeg";

export const constructionCalendar = [
  {
    name: "Soil improvement",
    description:
      "Soil improvement is the alteration of any property of a soil to improve its engineering performance. Some sort of soil improvement must usually be done for almost every construction project.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Annual",
    bestMonths: ["June", "July"],
    otherMonths: ["August"],
    image: PitchforkSoilManImage,
  },
  {
    name: "Tidy up",
    description:
      "Clean up the garden by removing dead leaves, branches and other debris. This will help prevent pests and diseases from overwintering and will also make your garden look tidier.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Quarterly",
    bestMonths: ["Novemeber", "June", "February", "January", "December"],
    otherMonths: "all",
    image: GardenTools,
  },
  {
    name: "Maintenance, repair jobs and hardscaping",
    description: "Maintenance, repair jobs and hardscaping",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "As needed",
    bestMonths: ["December", "June", "July"],
    otherMonths: "all",
    image: ManLayingBrickPathImage,
  },
  {
    name: "Dangerous tree branch removal",
    description:
      "Remove any dead or dangerous branches from trees. This will help prevent damage to your property and injury to people or pets.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "As needed",
    bestMonths: ["November", "June", "July"],
    images: DeadBranchImage,
  },
  {
    name: "Shade analysis",
    description:
      "Shade analysis is the process of determining the amount of shade that a particular site receives. This is important for determining what plants will grow best in a given location. Or where you want shade so you can sit and relax.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "Annual",
    bestMonths: ["December", "Janurary"],
    images: GardenFurnitureInSun,
  },
];
